import { render, staticRenderFns } from "./custom-component-common-display.vue?vue&type=template&id=31ba2261&scoped=true&"
import script from "./custom-component-common-display.vue?vue&type=script&lang=js&"
export * from "./custom-component-common-display.vue?vue&type=script&lang=js&"
import style0 from "./custom-component-common-display.vue?vue&type=style&index=0&id=31ba2261&scoped=true&lang=scss&"
import style1 from "./custom-component-common-display.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba2261",
  null
  
)

export default component.exports